/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Activity } from './Activity';
import {
    ActivityFromJSON,
    ActivityFromJSONTyped,
    ActivityToJSON,
} from './Activity';
import type { VersionMetadata } from './VersionMetadata';
import {
    VersionMetadataFromJSON,
    VersionMetadataFromJSONTyped,
    VersionMetadataToJSON,
} from './VersionMetadata';

/**
 * 
 * @export
 * @interface Reposts
 */
export interface Reposts {
    /**
     * 
     * @type {number}
     * @memberof Reposts
     */
    latestChainBlock: number;
    /**
     * 
     * @type {number}
     * @memberof Reposts
     */
    latestIndexedBlock: number;
    /**
     * 
     * @type {number}
     * @memberof Reposts
     */
    latestChainSlotPlays: number;
    /**
     * 
     * @type {number}
     * @memberof Reposts
     */
    latestIndexedSlotPlays: number;
    /**
     * 
     * @type {string}
     * @memberof Reposts
     */
    signature: string;
    /**
     * 
     * @type {string}
     * @memberof Reposts
     */
    timestamp: string;
    /**
     * 
     * @type {VersionMetadata}
     * @memberof Reposts
     */
    version: VersionMetadata;
    /**
     * 
     * @type {Array<Activity>}
     * @memberof Reposts
     */
    data?: Array<Activity>;
}

/**
 * Check if a given object implements the Reposts interface.
 */
export function instanceOfReposts(value: object): value is Reposts {
    let isInstance = true;
    isInstance = isInstance && "latestChainBlock" in value && value["latestChainBlock"] !== undefined;
    isInstance = isInstance && "latestIndexedBlock" in value && value["latestIndexedBlock"] !== undefined;
    isInstance = isInstance && "latestChainSlotPlays" in value && value["latestChainSlotPlays"] !== undefined;
    isInstance = isInstance && "latestIndexedSlotPlays" in value && value["latestIndexedSlotPlays"] !== undefined;
    isInstance = isInstance && "signature" in value && value["signature"] !== undefined;
    isInstance = isInstance && "timestamp" in value && value["timestamp"] !== undefined;
    isInstance = isInstance && "version" in value && value["version"] !== undefined;

    return isInstance;
}

export function RepostsFromJSON(json: any): Reposts {
    return RepostsFromJSONTyped(json, false);
}

export function RepostsFromJSONTyped(json: any, ignoreDiscriminator: boolean): Reposts {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'latestChainBlock': json['latest_chain_block'],
        'latestIndexedBlock': json['latest_indexed_block'],
        'latestChainSlotPlays': json['latest_chain_slot_plays'],
        'latestIndexedSlotPlays': json['latest_indexed_slot_plays'],
        'signature': json['signature'],
        'timestamp': json['timestamp'],
        'version': VersionMetadataFromJSON(json['version']),
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(ActivityFromJSON)),
    };
}

export function RepostsToJSON(value?: Reposts | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'latest_chain_block': value.latestChainBlock,
        'latest_indexed_block': value.latestIndexedBlock,
        'latest_chain_slot_plays': value.latestChainSlotPlays,
        'latest_indexed_slot_plays': value.latestIndexedSlotPlays,
        'signature': value.signature,
        'timestamp': value.timestamp,
        'version': VersionMetadataToJSON(value.version),
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(ActivityToJSON)),
    };
}

